import { render } from "./MovieDetailsArea.vue?vue&type=template&id=ad6664aa&scoped=true"
import script from "./MovieDetailsArea.vue?vue&type=script&lang=js"
export * from "./MovieDetailsArea.vue?vue&type=script&lang=js"

import "./MovieDetailsArea.vue?vue&type=style&index=0&id=ad6664aa&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad6664aa"]])

export default __exports__